/** @format */

// has raw color #rawcolor (comment to help find the comp in the near future for further updates)

import {forwardRef} from 'react';
import PropTypes from 'prop-types';

import {Icon} from '@sttark/design-system';
import classNames from 'classnames';

export const IconButton = forwardRef(
    ({secondary, small, large, icon, color, className, disabled, onClick, ...props}, ref) => {
        const buttonClasses = classNames(
            'icon-button',
            {
                'icon-button--secondary': secondary,
                'icon-button--small': small,
                'icon-button--large': large
            },
            className
        );

        return (
            <button
                className={buttonClasses}
                disabled={disabled}
                onClick={onClick}
                ref={ref}
                {...props}>
                <Icon
                    name={icon}
                    small={small}
                    large={large}
                    color={disabled ? '#a3abb2' : color}
                />
            </button>
        );
    }
);

IconButton.displayName = 'IconButton';

IconButton.propTypes = {
    secondary: PropTypes.bool,
    small: PropTypes.bool,
    large: PropTypes.bool,
    color: PropTypes.string,
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
};

IconButton.defaultProps = {
    icon: 'Check',
    color: '#000000',
    disabled: false
};
